/* eslint-disable camelcase */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable react/no-children-prop */
import React, { SyntheticEvent, useEffect, useState } from 'react';
import {
  Box,
  Button,
  Container,
  CssBaseline,
  Grid,
  List,
  ListItem,
  ListItemText,
  Modal,
  Typography,
} from '@mui/material';
import { toast } from 'react-toastify';
import useStyles from '../../assets/styles/pages/Login';

// import svg
import { ReactComponent as IconEmail } from '../../assets/images/svg/login/icon_email.svg';
import { ReactComponent as IconPassword } from '../../assets/images/svg/login/icon_senha.svg';
import { ReactComponent as IconArrow } from '../../assets/images/svg/recover_password/icon_arrow.svg';
import { ReactComponent as IconMail } from '../../assets/images/svg/recover_password/icon_mail.svg';
import { ReactComponent as IconInfo } from '../../assets/images/svg/utils/info.svg';
import { ReactComponent as IconPhone } from '../../assets/images/svg/sign_up/icon_phone.svg';

// import img
import { useLoadingContext } from '../../providers/use-loading';
import { ItypeReturnApi } from '../../helpers/utils/TypeReturnApi';
import { api } from '../../services';
import { isNumeric } from '../../helpers/utils/Formating';

const styleModal = {
  position: 'absolute' as const,
  bottom: '0px',
  width: '100%',
  maxWidth: 680,
  borderRadius: '32px 32px 0px 0px',
  bgcolor: 'background.paper',
  border: '2px solid #ffffff',
  boxShadow: 24,
  p: '10px 25px',
  outline: 'none',
};

const styleModalRecovePassword = {
  position: 'absolute' as const,
  width: '100%',
  maxWidth: 680,
  borderRadius: 8,
  p: 4,
  outline: 'none',
};

const ForgotPassword: React.FC = () => {
  const classeStyle = useStyles();
  const { createloading } = useLoadingContext();

  const [openModalRecoverPassword, setOpenModalRecoverPassword] =
    useState(false);
  const [btnStyleSelectedLoginType, setBtnStyleSelectedLoginType] =
    useState('email');
  const [openModalRecoverPasswordOption, setOpenModalRecoverPasswordOption] =
    useState(false);
  const [openModalRecovePasswordSmsAndWp, setOpenModalRecovePasswordSmsAndWp] =
    useState(false);
  const [openModalRecovePasswordEmail, setOpenModalRecovePasswordEmail] =
    useState(false);
  const [openUserNotParams, setOpenUserNotParams] = useState(false);
  const [modalText, setModalText] = useState({
    title: '',
    description: '',
  });
  const [existUser, setExistUser] = useState<any>();
  const [typeRecovePw, setTypeRecovePw] = useState<string>('');
  const [formSign, setFormSign] = useState({
    user_name: '',
    nrDDD: '',
    nrTelefone: '',
  });
  const [apiWhatsUse, setApiWhatsUse] = useState<boolean>(true);

  const handleOpenModalRecoverPassword = () =>
    setOpenModalRecoverPassword(true);
  const handleCloseModalRecoverPassword = () =>
    setOpenModalRecoverPassword(false);

  const handleChangeTypeLogin = (type: string) => {
    setBtnStyleSelectedLoginType(type);
  };

  const handleChangeForm = (event: any) => {
    const { name } = event.target;
    const { value } = event.target;

    setFormSign((field) => {
      return {
        ...field,
        [`${name}`]: value,
      };
    });
  };

  const handleSubimtCheckedUser = async (event: SyntheticEvent) => {
    event.preventDefault();
    if (btnStyleSelectedLoginType === 'phone') {
      if (
        formSign.nrDDD.trim() === '' ||
        !isNumeric(formSign.nrDDD) ||
        formSign.nrTelefone.trim() === '' ||
        !isNumeric(formSign.nrTelefone)
      ) {
        setModalText({
          title: 'Atenção',
          description: 'Informe um telefone válido!',
        });
        setOpenUserNotParams(true);
        return;
      }
    }
    if (formSign.user_name === '' && btnStyleSelectedLoginType !== 'phone') {
      setModalText({
        title: 'Atenção',
        description: `Informe seu e-mail`,
      });
      setOpenUserNotParams(true);
      return;
    }
    setOpenModalRecoverPassword(false);
    createloading(true);

    try {
      const userData: ItypeReturnApi =
        await api.apiMaisdelivery.auth.getDataUser({
          nr_operacao: 39,
          dsEmail: formSign.user_name ? formSign.user_name : 0,
          nrDDD: formSign.nrDDD ? formSign.nrDDD : 0,
          nrTelefone: formSign.nrTelefone ? formSign.nrTelefone : 0,
          idUsuario_filtro: 0,
        });
      createloading(false);
      if (userData.data.length > 0) {
        setExistUser(userData.data);
        setOpenModalRecoverPasswordOption(true);
        return;
      }
    } catch (error) {
      createloading(false);
      toast.error('Ocorreu erro ao recuperar sua senha.');
    }
  };

  const handleRecovePassword = async (id: any, type: string) => {
    setOpenModalRecoverPassword(false);
    setOpenModalRecovePasswordSmsAndWp(false);
    setOpenModalRecovePasswordEmail(false);
    setOpenModalRecoverPasswordOption(false);
    let typeText = '';

    createloading(true);
    try {
      let userData: any;
      if (type === 'email') {
        typeText = 'e-mail';
        userData = await api.apiMaisdelivery.auth.recovePassword({
          nr_operacao: 42,
          idUsuario: id,
        });
      }

      if (type === 'sms') {
        typeText = 'SMS';
        userData = await api.apiMaisdelivery.auth.recovePassword({
          nr_operacao: 41,
          idUsuario: id,
        });
      }

      if (type === 'whatsapp') {
        typeText = 'WhatsApp';
        userData = await api.apiMaisdelivery.auth.recovePassword({
          nr_operacao: 40,
          idUsuario: id,
        });
      }

      createloading(false);
      if (userData.data.retorno === 'NOK') {
        toast.error(`Ocorreu erro ao enviar sua senha `);
        return;
      }
      setModalText({
        title: 'Informação',
        description: `Sua senha foi enviada via ${typeText}`,
      });
      setOpenUserNotParams(true);
      await new Promise((resolve) => {
        setTimeout(resolve, 3000);
      });
      setOpenUserNotParams(false);
    } catch (error) {
      setOpenUserNotParams(false);
      createloading(false);
      toast.error('Ocorreu erro ao recuperar sua senha.');
    }
  };

  const handleModalRecovePasswordSmsAndWp = (type: string) => {
    setTypeRecovePw(type);
    setOpenModalRecoverPasswordOption(false);
    setOpenModalRecovePasswordSmsAndWp(true);
  };

  const handleModalRecovePasswordEmail = (type: string) => {
    setTypeRecovePw(type);
    setOpenModalRecoverPasswordOption(false);
    setOpenModalRecovePasswordEmail(true);
  };

  const handleCheckApiToWhats = async () => {
    try {
      const result: any = await api.apiMaisdelivery.auth.recovePassword({
        nr_operacao: 70,
      });

      if (result.data.status === 'NOK') {
        setApiWhatsUse(false);
      }
    } catch (error) {
      toast.error('Ocorreu erro.');
    }
  };

  useEffect(() => {
    setFormSign({
      user_name: '',
      nrDDD: '',
      nrTelefone: '',
    });
  }, [btnStyleSelectedLoginType]);

  useEffect(() => {
    handleCheckApiToWhats();
  }, []);

  return (
    <Container maxWidth={false} className={classeStyle.container}>
      <CssBaseline />
      <Grid
        container
        item
        justifyContent="center"
        alignItems="center"
        textAlign="center"
      >
        <Grid
          container
          item
          justifyContent="center"
          alignItems="center"
          textAlign="center"
          className={classeStyle.gridForm}
        >
          <Button
            color="secondary"
            onClick={handleOpenModalRecoverPassword}
            className={classeStyle.btnRecovePassword}
          >
            Esqueceu a senha? Clique aqui
          </Button>
          <Modal
            open={openModalRecoverPassword}
            onClose={handleCloseModalRecoverPassword}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={{ ...styleModal }}>
              <Grid container item xs={12} justifyContent="center">
                <IconMail className={classeStyle.iconModal} />
              </Grid>
              <Grid container item xs={12} justifyContent="center">
                <Typography
                  id="modal-modal-title"
                  variant="h6"
                  component="h2"
                  className={classeStyle.titleModal}
                  style={{ fontWeight: '550' }}
                >
                  Recuperação
                </Typography>
                <Grid item xs={12}>
                  <Typography
                    id="modal-modal-description"
                    sx={{ mt: 2 }}
                    style={{ fontSize: 12 }}
                    className={classeStyle.textModal}
                  >
                    Uma nova senha será enviada ao seu{' '}
                    {btnStyleSelectedLoginType === 'email'
                      ? 'email'
                      : 'telefone'}
                    , digiti-o abaixo!
                  </Typography>
                </Grid>
              </Grid>
              <Grid container justifyContent="center" marginBottom="10px">
                <Button
                  onClick={() => handleChangeTypeLogin('email')}
                  className={
                    btnStyleSelectedLoginType === 'email'
                      ? classeStyle.btnLoginTypeSelected
                      : classeStyle.btnLoginType
                  }
                  variant="outlined"
                >
                  E-mail
                </Button>
                <Button
                  onClick={() => handleChangeTypeLogin('phone')}
                  className={
                    btnStyleSelectedLoginType === 'phone'
                      ? classeStyle.btnLoginTypeSelected
                      : classeStyle.btnLoginType
                  }
                  variant="outlined"
                >
                  Celular
                </Button>
              </Grid>
              <form onSubmit={handleSubimtCheckedUser}>
                <Grid
                  container
                  item
                  justifyContent="flex-start"
                  alignItems="center"
                  textAlign="center"
                >
                  {btnStyleSelectedLoginType === 'email' ? (
                    <Grid
                      container
                      item
                      justifyContent="flex-start"
                      alignItems="center"
                      textAlign="center"
                    >
                      <IconEmail className={classeStyle.icon} />
                      <input
                        type="text"
                        className={classeStyle.inputText}
                        placeholder="Preencha o seu E-mail"
                        name="user_name"
                        onChange={handleChangeForm}
                      />
                    </Grid>
                  ) : (
                    <Grid
                      container
                      item
                      justifyContent="flex-start"
                      alignItems="center"
                      textAlign="center"
                    >
                      <IconPhone className={classeStyle.icon} />
                      <Grid container item>
                        <Grid item xs={4} marginLeft="0px">
                          <input
                            type="text"
                            className={classeStyle.inputText}
                            placeholder="DDD"
                            value={formSign.nrDDD}
                            name="nrDDD"
                            size={3}
                            maxLength={3}
                            onChange={handleChangeForm}
                          />
                        </Grid>
                        <Grid item xs={8}>
                          <input
                            type="text"
                            className={classeStyle.inputText}
                            placeholder="+ Telefone"
                            size={9}
                            maxLength={9}
                            value={formSign.nrTelefone}
                            name="nrTelefone"
                            onChange={handleChangeForm}
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                  )}
                </Grid>
                <Button
                  className={classeStyle.btnSubmit}
                  type="submit"
                  variant="contained"
                >
                  Enviar
                  <IconArrow className={classeStyle.iconArrow} />
                </Button>
              </form>
            </Box>
          </Modal>
          <Modal
            open={openModalRecoverPasswordOption}
            onClose={() => setOpenModalRecoverPasswordOption(false)}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={{ ...styleModal }}>
              <Grid container item xs={12} justifyContent="center">
                <IconPassword className={classeStyle.iconModal} />
              </Grid>
              <Grid container item xs={12} justifyContent="center">
                <Typography
                  id="modal-modal-title"
                  variant="h6"
                  component="h2"
                  className={classeStyle.titleModal}
                  style={{
                    fontWeight: '550',
                    width: '100%',
                    textAlign: 'center',
                  }}
                >
                  Recuperar senha!
                </Typography>
                <Typography
                  id="modal-modal-description"
                  sx={{ mt: 2 }}
                  style={{ fontSize: 13 }}
                  className={classeStyle.textModal}
                >
                  Se você esqueceu sua senha escolha uma das opções abaixo para
                  recuperar a sua senha.
                </Typography>
              </Grid>
              {btnStyleSelectedLoginType === 'email' ? (
                <>
                  <Button
                    className={classeStyle.btnModal}
                    onClick={() =>
                      handleRecovePassword(existUser[0].idUsuario, 'email')
                    }
                    variant="contained"
                  >
                    Enviar senha por E-mail
                  </Button>
                  {apiWhatsUse && (
                    <Button
                      className={classeStyle.btnModalSegund}
                      onClick={() =>
                        handleModalRecovePasswordSmsAndWp('whatsapp')
                      }
                      variant="contained"
                    >
                      Enviar senha por WhatsApp
                    </Button>
                  )}
                  <Button
                    className={classeStyle.btnModalWhite}
                    onClick={() => handleModalRecovePasswordSmsAndWp('sms')}
                    variant="contained"
                  >
                    Enviar senha por SMS
                  </Button>
                </>
              ) : (
                <>
                  <Button
                    className={classeStyle.btnModal}
                    onClick={() => handleModalRecovePasswordEmail('email')}
                    variant="contained"
                  >
                    Enviar senha por E-mail
                  </Button>
                  {apiWhatsUse && (
                    <Button
                      className={classeStyle.btnModalSegund}
                      onClick={() =>
                        handleRecovePassword(existUser[0].idUsuario, 'whatsapp')
                      }
                      variant="contained"
                    >
                      Enviar senha por WhatsApp
                    </Button>
                  )}
                  <Button
                    className={classeStyle.btnModalWhite}
                    onClick={() =>
                      handleRecovePassword(existUser[0].idUsuario, 'sms')
                    }
                    variant="contained"
                  >
                    Enviar senha por SMS
                  </Button>
                </>
              )}
            </Box>
          </Modal>
          <Modal
            open={openModalRecovePasswordSmsAndWp}
            onClose={() => setOpenModalRecovePasswordSmsAndWp(false)}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={styleModalRecovePassword}>
              <Grid
                container
                item
                textAlign="center"
                justifyContent="center"
                xs={12}
                className={classeStyle.contentModal}
              >
                <h3 className={classeStyle.titleModalRv}>
                  ESCOLHA O SEU NÚMERO
                </h3>
              </Grid>
              <Grid
                container
                item
                textAlign="center"
                justifyContent="center"
                alignItems="center"
              >
                <Box
                  sx={{
                    width: '100%',
                    height: 'auto',
                  }}
                >
                  <List
                    sx={{
                      width: '100%',
                      bgcolor: 'background.paper',
                      position: 'relative',
                      overflow: 'auto',
                      maxHeight: 350,
                      border: ' solid 1px #dfd0d0',
                      borderBottomRightRadius: 10,
                      borderBottomLeftRadius: 10,
                      '& ul': { padding: 0 },
                    }}
                    subheader={<li />}
                  >
                    <li>
                      <ul>
                        <ListItem className={classeStyle.gridTitleSegund}>
                          <ListItemText
                            className={classeStyle.titleSegund}
                            primary="Seu número não está na lista? Mudou de número? Escolha a opção enviar por email."
                          />
                        </ListItem>
                      </ul>
                    </li>
                    {existUser?.map((dataExist: any) => (
                      <li key={`${dataExist.idUsuario}`}>
                        <ul>
                          <ListItem className={classeStyle.gridNameModal}>
                            <ListItemText
                              className={classeStyle.nameModal}
                              onClick={() =>
                                handleRecovePassword(
                                  dataExist.idUsuario,
                                  typeRecovePw,
                                )
                              }
                              primary={`(${
                                dataExist.nrDDD
                              }) 9XXXX-${dataExist.nrTelefone.substring(
                                5,
                                9,
                              )} `}
                            />
                          </ListItem>
                        </ul>
                      </li>
                    ))}
                  </List>
                </Box>
              </Grid>
            </Box>
          </Modal>
          <Modal
            open={openModalRecovePasswordEmail}
            onClose={() => setOpenModalRecovePasswordEmail(false)}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={styleModalRecovePassword}>
              <Grid
                container
                item
                textAlign="center"
                justifyContent="center"
                xs={12}
                className={classeStyle.contentModal}
              >
                <h3 className={classeStyle.titleModalRv}>
                  ESCOLHA O SEU E-MAIL
                </h3>
              </Grid>
              <Grid
                container
                item
                textAlign="center"
                justifyContent="center"
                alignItems="center"
              >
                <Box
                  sx={{
                    width: '100%',
                    height: 'auto',
                  }}
                >
                  <List
                    sx={{
                      width: '100%',
                      bgcolor: 'background.paper',
                      position: 'relative',
                      overflow: 'auto',
                      maxHeight: 350,
                      border: ' solid 1px #dfd0d0',
                      borderBottomRightRadius: 10,
                      borderBottomLeftRadius: 10,
                      '& ul': { padding: 0 },
                    }}
                    subheader={<li />}
                  >
                    <li>
                      <ul>
                        <ListItem className={classeStyle.gridTitleSegund}>
                          <ListItemText
                            className={classeStyle.titleSegund}
                            primary="Seu e-mail não está na lista? Mudou seu e-mail? Escolha a opção enviar por SMS."
                          />
                        </ListItem>
                      </ul>
                    </li>
                    {existUser?.map((dataExist: any) => (
                      <li key={`${dataExist.idUsuario}`}>
                        <ul>
                          <ListItem className={classeStyle.gridNameModal}>
                            <ListItemText
                              className={classeStyle.nameModal}
                              onClick={() =>
                                handleRecovePassword(
                                  dataExist.idUsuario,
                                  typeRecovePw,
                                )
                              }
                              primary={`${dataExist.dsEmail.substring(
                                0,
                                3,
                              )}'******'${dataExist.dsEmail.substring(
                                dataExist.dsEmail.indexOf('@'),
                                dataExist.dsEmail.length,
                              )}`}
                            />
                          </ListItem>
                        </ul>
                      </li>
                    ))}
                  </List>
                </Box>
              </Grid>
            </Box>
          </Modal>
        </Grid>
      </Grid>
      <Modal
        open={openUserNotParams}
        onClose={() => setOpenUserNotParams(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={{ ...styleModal }}>
          <Grid container item xs={12} justifyContent="center">
            <IconInfo className={classeStyle.iconModal} />
          </Grid>
          <Grid container item xs={12} justifyContent="center">
            <Typography
              id="modal-modal-title"
              variant="h6"
              component="h2"
              className={classeStyle.titleModal}
              style={{ fontWeight: '550', width: '100%', textAlign: 'center' }}
            >
              {modalText.title}
            </Typography>
            <Typography
              id="modal-modal-description"
              sx={{ mt: 2 }}
              className={classeStyle.textModal}
            >
              {modalText.description}
            </Typography>
          </Grid>
          <Button
            className={classeStyle.btnSubmit}
            onClick={() => setOpenUserNotParams(false)}
            variant="contained"
          >
            Ok
          </Button>
        </Box>
      </Modal>
    </Container>
  );
};

export default ForgotPassword;
